// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"37eb1e26c6bdba9985ed","966":"f0ce61b681f73e438823"}[chunkId] + ".js";
};